// removed by extract-text-webpack-plugin
module.exports = {"container":"PrivacyPolicyLink__container___3N-au","link":"PrivacyPolicyLink__link___3r854"};